export function normalizeBook(book) {
  if (!book) return null;
  return {
    id: book._id || book.id,
    _id: book._id,
    title: book.title,
    isbn: book.isbn,
    slug: book.slug,
    genre: book.genre,
    language: book.language,
    format: book.format || [],
    price: book.price,
    mrp: book.mrp || book.price,
    rating: book.rating || 0,
    reviewsCount: book.reviewsCount || 0,
    pages: book.pages,
    manuscriptSize: book.manuscriptSize,
    published: book.published || book.createdAt,
    cover: book.cover,
    description: book.description,
    tags: book.tags || [],
    chapters: (book.chapters || []).slice().sort((a, b) => a.chapterNumber - b.chapterNumber),
    badge: book.badge,
    isActive: book.isActive,
    adminApproved: book.adminApproved || false,
    feeRequired: book.feeRequired || false,
    feeStatus: book.feeStatus || 'not_required',
    isCuratedFreeDownload: book.isCuratedFreeDownload || false,
    earlyAccessEnabled: book.earlyAccessEnabled || false,
    releaseDate: book.releaseDate,
    publicReleaseDate: book.publicReleaseDate,
    earlyAccessEndDate: book.earlyAccessEndDate,
    earlyAccessMemberships: book.earlyAccessMemberships || [],
    // Present when the API annotated this book with the centralized
    // entitlement object (list/detail endpoints) — see
    // server/services/membershipService.js's getEarlyAccessStatus.
    earlyAccess: book.earlyAccess || null,
    featured: book.featured || false,
    featuredUntil: book.featuredUntil,
    featuredPriority: book.featuredPriority || 0,
    affiliateEnabled: book.affiliateEnabled || false,
    affiliateCommissionPercent: book.affiliateCommissionPercent || 0,
    author: book.author
      ? {
        id: book.author._id || book.author.id,
        name: book.author.name,
        slug: book.author.slug,
        avatar: book.author.avatar,
        bio: book.author.bio || '',
        followers: book.author.followers || 0,
        isFollowing: Boolean(book.author.isFollowing),
        email: book.author.email,
      }
      : null,
    authorId: book.author?._id || book.author?.id,
    authorName: book.authorName,
  };
}

export function normalizeBooks(books) {
  return (books || []).map(normalizeBook);
}

export function normalizeAuthor(author) {
  if (!author) return null;
  return {
    id: author._id || author.id,
    _id: author._id,
    name: author.name,
    slug: author.slug,
    avatar: author.avatar,
    bio: author.bio || '',
    followers: author.followers || 0,
    books: author.booksPublished || 0,
    isFollowing: Boolean(author.isFollowing),
  };
}

export function normalizeAuthors(authors) {
  return (authors || []).map(normalizeAuthor);
}

export function normalizeReview(review) {
  if (!review) return null;
  return {
    id: review._id || review.id,
    rating: review.rating,
    text: review.text || '',
    date: review.createdAt,
    name: review.user?.name || review.reviewerName || 'Anonymous',
    avatar: review.user?.avatar,
    approved: review.approved !== false,
  };
}

export function normalizeReviews(reviews) {
  return (reviews || []).map(normalizeReview);
}

export function normalizePost(post) {
  if (!post) return null;
  return {
    id: post._id || post.id,
    _id: post._id,
    title: post.title,
    slug: post.slug,
    excerpt: post.excerpt || '',
    content: post.content || '',
    cover: post.cover,
    authorName: post.authorName || 'Book Cloud Team',
    tags: post.tags || [],
    status: post.status,
    readTime: post.readTime || 1,
    date: post.publishedAt || post.createdAt,
  };
}

export function normalizePosts(posts) {
  return (posts || []).map(normalizePost);
}
